import { createStore } from "zustand/vanilla";
import dayjs from "dayjs";

const startInterval = (cb: (time: number) => void, delay = 1000) => {
  let time = 0;
  cb(time);
  const id = window.setInterval(() => {
    time += delay;
    cb(time);
  }, delay);

  return () => window.clearInterval(id);
};

export type TTimerRepo = {
  time: number;
  current_timer: string;
  session_timer: string;
  start: () => () => void;
};

export const timerRepo = createStore<TTimerRepo>((set, get) => {
  return {
    time: 0,
    current_timer: "",
    session_timer: "",
    start: () =>
      startInterval((time) => {
        set({
          time,
          current_timer: dayjs().format("HH:mm"),
          session_timer: dayjs.duration(time).format("HH:mm:ss"),
        });
      }),
  };
});

export default timerRepo;
